import { render, staticRenderFns } from "./chateau-grand-puy-lacoste.vue?vue&type=template&id=3e6dd1bd&scoped=true"
import script from "./chateau-grand-puy-lacoste.vue?vue&type=script&lang=js"
export * from "./chateau-grand-puy-lacoste.vue?vue&type=script&lang=js"
import style0 from "./chateau-grand-puy-lacoste.vue?vue&type=style&index=0&id=3e6dd1bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6dd1bd",
  null
  
)

export default component.exports